import React from "react";
import { Cumpleaños }  from "../components/FelizCumpleaños";

const CumpleañosPagina = () => {
  return (
	<>
	  <div>
		<Cumpleaños/>
	  </div>
	</>
  );
};

export default CumpleañosPagina;